import React from "react";
import { BookMarked, ArrowRight } from "lucide-react";

export const PatternLibrary = ({ patterns = [], onReuse }) => (
    <section
        data-testid="pattern-library-browser"
        className="border border-slate-200 bg-white rounded-sm p-8 hover-lift"
    >
        <div className="flex items-start justify-between gap-6 flex-wrap mb-6">
            <div>
                <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                    Approved pattern library
                </div>
                <h2 className="mt-2 font-heading text-2xl lg:text-3xl font-semibold tracking-tight text-slate-900">
                    Reusable, governed prompt patterns
                </h2>
            </div>
            <p className="max-w-md text-sm text-slate-600 leading-relaxed">
                PromptCierge learns from approved prompt patterns, outcomes and
                receipts — not from uncontrolled private prompts.
            </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {patterns.map((p) => (
                <article
                    key={p.id}
                    data-testid={`pattern-${p.id}`}
                    className="border border-slate-200 rounded-sm p-5 bg-slate-50/40 hover:bg-white transition-colors flex flex-col"
                >
                    <div className="flex items-start justify-between gap-3">
                        <BookMarked className="h-4 w-4 text-slate-700" />
                        <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
                            {p.category}
                        </span>
                    </div>
                    <div className="mt-3 font-heading text-base font-semibold text-slate-900">
                        {p.title}
                    </div>
                    <div className="font-mono text-[11px] text-slate-500 mt-1">
                        {p.id}
                    </div>
                    <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">
                        {p.description}
                    </p>
                    <dl className="mt-4 grid grid-cols-2 gap-2 text-xs">
                        <div>
                            <dt className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500">
                                Uses
                            </dt>
                            <dd className="text-slate-900 font-mono">{p.uses}</dd>
                        </div>
                        <div>
                            <dt className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500">
                                Cost index
                            </dt>
                            <dd className="text-slate-900 font-mono">
                                {p.avg_cost_index.toFixed(2)}×
                            </dd>
                        </div>
                    </dl>
                    {onReuse && (
                        <button
                            data-testid={`reuse-pattern-${p.id}`}
                            onClick={() => onReuse(p)}
                            className="mt-5 inline-flex items-center justify-between gap-2 border border-slate-300 rounded-sm px-3 py-2 text-xs text-slate-900 hover:bg-slate-900 hover:text-white transition-colors"
                        >
                            Reuse this pattern <ArrowRight className="h-3.5 w-3.5" />
                        </button>
                    )}
                </article>
            ))}
        </div>
    </section>
);

export default PatternLibrary;
